import React from 'react'

const Bari = () => {
  return (
    <div>
    <div className="bari-image1">
      <img
        src="https://shop.activeitzone.com/public/uploads/all/blLSJ3z9AsDbGZSXwWmWrMppHBhIYSb17yVUdkRK.webp"
        alt=""
        height="370px"
        width="100%"
      />
    </div>
    <div>
      <h2>Flash Sale</h2>
    </div>
    </div>
  )
}

export default Bari